/*-----------------------------------------------------------------
- Breadcrumbs translations
-----------------------------------------------------------------*/
export default {
    
    setting: {
        title: 'Site Settings',
    },
    
};
